// extracted by mini-css-extract-plugin
export default {"InputWrap":"index_InputWrap__e7md+","Input":"index_Input__gz4nl","BtnSend":"index_BtnSend__VBlES"};